import * as Types from '@/types';

import * as Apollo from '@apollo/client';
import { gql } from '@apollo/client';
import { useLazyQuery } from '@/hooks/use-lazy-query';
import { useWrappedQuery } from '@/hooks/use-wrapped-query';
const defaultOptions = {} as const;

export const GetOrderEntryEstimatedCommissionDocument = gql`
  query GetOrderEntryEstimatedCommission(
    $businessOrganizationUUID: uuid!
    $employeeUUID: uuid!
    $orderUUID: uuid!
  ) {
    getOrderEstimatedCommission(
      business_organization_id: $businessOrganizationUUID
      employee_id: $employeeUUID
      order_ids: [$orderUUID]
    ) {
      commissions {
        estimated_commission_in_micros
        order_id
      }
    }
  }
`;
export function useGetOrderEntryEstimatedCommissionQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.GetOrderEntryEstimatedCommissionQuery,
    Types.GetOrderEntryEstimatedCommissionQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.GetOrderEntryEstimatedCommissionQuery,
    Types.GetOrderEntryEstimatedCommissionQueryVariables
  >(GetOrderEntryEstimatedCommissionDocument, options);
}
export function useGetOrderEntryEstimatedCommissionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.GetOrderEntryEstimatedCommissionQuery,
    Types.GetOrderEntryEstimatedCommissionQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.GetOrderEntryEstimatedCommissionQuery,
    Types.GetOrderEntryEstimatedCommissionQueryVariables
  >(GetOrderEntryEstimatedCommissionDocument, options);
}
export type GetOrderEntryEstimatedCommissionQueryHookResult = ReturnType<
  typeof useGetOrderEntryEstimatedCommissionQuery
>;
export type GetOrderEntryEstimatedCommissionLazyQueryHookResult = ReturnType<
  typeof useGetOrderEntryEstimatedCommissionLazyQuery
>;
export type GetOrderEntryEstimatedCommissionQueryResult = Apollo.QueryResult<
  Types.GetOrderEntryEstimatedCommissionQuery,
  Types.GetOrderEntryEstimatedCommissionQueryVariables
>;

/**
 * Wrapped version of useGeneratedGetOrderEntryEstimatedCommissionQuery using Pepper's useWrappedQuery
 */
export function useGeneratedGetOrderEntryEstimatedCommissionQuery(
  options?: Apollo.QueryHookOptions<
    Types.GetOrderEntryEstimatedCommissionQuery,
    Types.GetOrderEntryEstimatedCommissionQueryVariables
  >,
) {
  return useWrappedQuery<
    Types.GetOrderEntryEstimatedCommissionQuery,
    Types.GetOrderEntryEstimatedCommissionQueryVariables
  >(GetOrderEntryEstimatedCommissionDocument, options);
}

/**
 * Wrapped version of useGeneratedGetOrderEntryEstimatedCommissionLazyQuery using Pepper's useLazyQuery
 */
export function useGeneratedGetOrderEntryEstimatedCommissionLazyQuery(
  lazyOptions?: Omit<
    Apollo.QueryOptions<Types.GetOrderEntryEstimatedCommissionQueryVariables>,
    'query'
  >,
) {
  return useLazyQuery<
    Types.GetOrderEntryEstimatedCommissionQuery,
    Types.GetOrderEntryEstimatedCommissionQueryVariables
  >(GetOrderEntryEstimatedCommissionDocument, lazyOptions);
}
